<template>
    <!--==========================
    Header
  ============================-->
    <header id="header">
        <div class="container">
            <div id="logo" class="pull-left">
                <a href="#/main/home"><img :src="`images/logo_${currentLanguage}.png`" alt="" title="" /></a>
                <!-- Uncomment below if you prefer to use an image logo -->
                <!-- <a href="#body"><img src="img/logo.png" alt="" title="" /></a>-->
            </div>

            <nav id="nav-menu-container">
                <el-menu mode="horizontal" :default-active="currentActive" router @select="handleCommand" class="main-menu">
                    <el-menu-item index="/main/home" route="/main/home">
                        <span slot="title">{{lang.homePage}}</span>
                    </el-menu-item>
                    <el-submenu index="/main/product" @click.native="gotoProductPage('/main/product/SCORPIO4')">
                        <span slot="title">{{lang.productPage}}</span>
                        <el-submenu index="/main/product/SCORPIO">
                            <template slot="title">SCORPIO</template>
                            <el-menu-item index="/main/product/SCORPIO4" route="/main/product/SCORPIO4"
                                >SCORPIO4</el-menu-item
                            >
                            <el-menu-item index="/main/product/SCORPIO3" route="/main/product/SCORPIO3"
                                >SCORPIO3</el-menu-item
                            >
                        </el-submenu>
                        <el-submenu index="/main/product/LIBRA">
                            <template slot="title">LIBRA</template>
                            <el-menu-item  index="/main/product/LIBRA4">LIBRA4</el-menu-item>
                            <el-menu-item  index="/main/product/LIBRA3">LIBRA3</el-menu-item>
                            <el-menu-item  index="/main/product/LIBRA2">LIBRA2</el-menu-item>
                        </el-submenu>
                        <el-submenu index="/main/product/GEMINI40T">
                            <template slot="title">GEMINI40T</template>
                            <el-menu-item  index="/main/product/GEMINI40T">GEMINI40T</el-menu-item>
                        </el-submenu>
                    </el-submenu>
                    <el-menu-item index="/main/application" route="/main/application">
                        <span slot="title">{{lang.scenePage}}</span>
                    </el-menu-item>
                    <el-menu-item index="/main/videoGallery" route="/main/videoGallery">
                        <span slot="title">{{lang.videoPage}}</span>
                    </el-menu-item>
                    <el-menu-item index="/main/support" route="/main/support">
                        <span slot="title">{{lang.supportPage}}</span>
                    </el-menu-item>
                    <el-menu-item index="/main/contact" route="/main/contact">
                        <span slot="title">{{lang.contactPage}}</span>
                    </el-menu-item>
                </el-menu>
            </nav>
            <!-- #nav-menu-container -->
            <button type="button" id="mobile-nav-toggle" @click.stop="toggleButton">
                <i class="fa fa-bars" v-show="!isOpenOverly"></i>
                <i class="fa fa-times" v-show="isOpenOverly"></i>
            </button>
        </div>

        <el-drawer
            :visible.sync="isOpenOverly"
            direction="ltr"
            :with-header="false"
            :size="'100%'"
            id="mobile-nav"
            append-to-body
        >
            <div class="drawer-close-btn" @click="toggleButton">
                <i class="fa fa-times"></i>
            </div>
            <el-menu
                :default-active.sync="currentActive"
                background-color="#343b40e6"
                text-color="#fff"
                active-text-color="#ffd04b"
                router
                @select="handleCommand"
                class="mobile-menu"
            >
                <el-menu-item index="/main/home" route="/main/home" class="custom-menu-item">
                    <div class="menu-item-content" @click.stop="gotoPage('/main/home')">
                        <span slot="title">{{lang.homePage}}</span>
                    </div>
                </el-menu-item>
                <el-submenu index="/main/product" class="custom-submenu">
                    <template slot="title">
                        <div class="menu-item-content" @click.stop="gotoPage('/main/product/SCORPIO4')">
                            <span>{{lang.productPage}}</span>
                        </div>
                    </template>
                    <el-submenu index="/main/product/SCORPIO" class="custom-submenu">
                        <template slot="title">
                            <div class="menu-item-content" @click.stop="gotoPage('/main/product/SCORPIO4')">
                                <span>SCORPIO</span>
                            </div>
                        </template>
                        <el-menu-item index="/main/product/SCORPIO4" route="/main/product/SCORPIO4" class="custom-menu-item">
                            <div class="menu-item-content" @click.stop="gotoPage('/main/product/SCORPIO4')">
                                <span>SCORPIO4</span>
                            </div>
                        </el-menu-item>
                        <el-menu-item index="/main/product/SCORPIO3" route="/main/product/SCORPIO3" class="custom-menu-item">
                            <div class="menu-item-content" @click.stop="gotoPage('/main/product/SCORPIO3')">
                                <span>SCORPIO3</span>
                            </div>
                        </el-menu-item>
                    </el-submenu>
                    <el-submenu index="/main/product/LIBRA" class="custom-submenu">
                        <template slot="title">
                            <div class="menu-item-content" @click.stop="gotoPage('/main/product/LIBRA4')">
                                <span>LIBRA</span>
                            </div>
                        </template>
                        <el-menu-item index="/main/product/LIBRA4" class="custom-menu-item">
                            <div class="menu-item-content" @click.stop="gotoPage('/main/product/LIBRA4')">
                                <span>LIBRA4</span>
                            </div>
                        </el-menu-item>
                        <el-menu-item index="/main/product/LIBRA3" class="custom-menu-item">
                            <div class="menu-item-content" @click.stop="gotoPage('/main/product/LIBRA3')">
                                <span>LIBRA3</span>
                            </div>
                        </el-menu-item>
                        <el-menu-item index="/main/product/LIBRA2" class="custom-menu-item">
                            <div class="menu-item-content" @click.stop="gotoPage('/main/product/LIBRA2')">
                                <span>LIBRA2</span>
                            </div>
                        </el-menu-item>
                    </el-submenu>
                    <el-submenu index="/main/product/GEMINI40T" class="custom-submenu">
                        <template slot="title">
                            <div class="menu-item-content" @click.stop="gotoPage('/main/product/GEMINI40T')">
                                <span>GEMINI40T</span>
                            </div>
                        </template>
                        <el-menu-item index="/main/product/GEMINI40T" class="custom-menu-item">
                            <div class="menu-item-content" @click.stop="gotoPage('/main/product/GEMINI40T')">
                                <span>GEMINI40T</span>
                            </div>
                        </el-menu-item>
                    </el-submenu>
                </el-submenu>
                <el-menu-item index="/main/application" route="/main/application" class="custom-menu-item">
                    <div class="menu-item-content" @click.stop="gotoPage('/main/application')">
                        <span slot="title">{{lang.scenePage}}</span>
                    </div>
                </el-menu-item>
                <el-menu-item index="/main/videoGallery" route="/main/videoGallery" class="custom-menu-item">
                    <div class="menu-item-content" @click.stop="gotoPage('/main/videoGallery')">
                        <span slot="title">{{lang.videoPage}}</span>
                    </div>
                </el-menu-item>
                <el-menu-item index="/main/support" route="/main/support" class="custom-menu-item">
                    <div class="menu-item-content" @click.stop="gotoPage('/main/support')">
                        <span slot="title">{{lang.supportPage}}</span>
                    </div>
                </el-menu-item>
                <el-menu-item index="/main/contact" route="/main/contact" class="custom-menu-item">
                    <div class="menu-item-content" @click.stop="gotoPage('/main/contact')">
                        <span slot="title">{{lang.contactPage}}</span>
                    </div>
                </el-menu-item>
            </el-menu>
        </el-drawer>
        <el-dropdown trigger="click" class="language_change" @command="selectLanguage">
            <span class="el-dropdown-link">
                {{ currentLanguageLabel }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="item.language" v-for="item in languageData" :key="item.language">{{
                    item.label
                }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </header>
    <!-- #header -->
</template>
<script>
import languages from '@/common/language'
export default {
    mixins: [],
    name: "navMenu",
    components: {},
    computed: {
        lang() {
            return this.$store.state.language;
        },
    },
    data() {
        return {
            isOpenOverly: false,
            currentActive: "/main/home",
            currentLanguageLabel: "",
            currentLanguage: "EN",
            languageData: [
                {
                    language: "CN",
                    label: "中文",
                },
                {
                    language: "EN",
                    label: "English",
                },
            ],
        };
    },
    watch: {
        "$route.path": {
            handler(path) {
                this.currentActive = path;
            },
            immediate: true,
        },
    },
    async beforeCreate() {},
    async created() {
        const item = this.languageData.find((item) => item.language === this.lang.currentLanguage);
        this.currentLanguageLabel = item && item.label;
        this.currentLanguage = item && item.language;
    },
    async beforeMount() {},
    mounted() {
        this.$nextTick(() => {
            // // Initiate superfish on nav menu
            // $(".nav-menu").superfish({
            //     animation: {
            //         opacity: "show",
            //     },
            //     speed: 400,
            // });
            // // Mobile Navigation
            // if ($("#nav-menu-container").length) {
            //     var $mobile_nav = $("#nav-menu-container").clone().prop({
            //         id: "mobile-nav",
            //     });
            //     $mobile_nav.find("> ul").attr({
            //         class: "",
            //         id: "",
            //     });
            //     $("body").append($mobile_nav);
            //     $("body").prepend('<button type="button" id="mobile-nav-toggle"><i class="fa fa-bars"></i></button>');
            //     $("body").append('<div id="mobile-body-overly"></div>');
            //     $("#mobile-nav").find(".menu-has-children").prepend('<i class="fa fa-chevron-down"></i>');
            //     $(document).on("click", ".menu-has-children i", function (e) {
            //         $(this).next().toggleClass("menu-item-active");
            //         $(this).nextAll("ul").eq(0).slideToggle();
            //         $(this).toggleClass("fa-chevron-up fa-chevron-down");
            //     });
            //     $(document).on("click", "#mobile-nav-toggle", function (e) {
            //         $("body").toggleClass("mobile-nav-active");
            //         $("#mobile-nav-toggle i").toggleClass("fa-times fa-bars");
            //         $("#mobile-body-overly").toggle();
            //     });
            //     $(document).click(function (e) {
            //         var container = $("#mobile-nav, #mobile-nav-toggle");
            //         if (!container.is(e.target) && container.has(e.target).length === 0) {
            //             if ($("body").hasClass("mobile-nav-active")) {
            //                 $("body").removeClass("mobile-nav-active");
            //                 $("#mobile-nav-toggle i").toggleClass("fa-times fa-bars");
            //                 $("#mobile-body-overly").fadeOut();
            //             }
            //         }
            //     });
            // } else if ($("#mobile-nav, #mobile-nav-toggle").length) {
            //     $("#mobile-nav, #mobile-nav-toggle").hide();
            // }
        });
    },
    methods: {
        gotoProductPage(target) {
            this.isOpenOverly = false
            this.$router.push(target);
        },
        gotoPage(path) {
            this.isOpenOverly = false;
            this.$router.push(path);
        },
        toggleButton() {
            this.isOpenOverly = !this.isOpenOverly;
        },
        selectLanguage(item){
            if(item === this.currentLanguage){
                return
            }
            this.currentLanguage = item
            const languageItem = this.languageData.find(item=>item.language === this.currentLanguage)
            this.currentLanguageLabel = languageItem&&languageItem.label

            this.$store.commit('setLanguage', languages[this.currentLanguage]);
            this.$store.commit('setLanguage', {currentLanguage:this.currentLanguage});
        },
        handleCommand(){
            this.isOpenOverly = false
        }
    },
};
</script>
<style lang="scss">
#header {
    padding: 15px 0;
    height: 80px;
    transition: all 0.3s ease;
    z-index: 997;
    background: #fff;
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    #logo {
        a {
            display: flex;
            align-items: center;
            img {
                width: auto;
                height: 50px;
                max-width: 300px;
                object-fit: contain;
            }
        }
    }
    .language_change {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 16px;
        cursor: pointer;
        
        .el-dropdown-link {
            padding: 5px 10px;
            border-radius: 4px;
            transition: all 0.3s;
            
            &:hover {
                background: rgba(0, 0, 0, 0.05);
            }
        }
    }
}

@media (max-width: 768px) {
    #header {
        padding: 15px 0;
        height: 70px;
        #logo {
            a {
                img {
                    height: 34px;
                    max-width: 200px;
                }
            }
        }
        .language_change {
            position: absolute;
            right: 60px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 14px;
        }
    }
}

/* Nav Menu Container */
#nav-menu-container {
    float: right;
    margin: 0;
    display: flex;
    align-items: center;
    height: 50px;
    
    .main-menu {
        border-bottom: none;
        background-color: transparent;
        
        .el-menu-item {
            font-size: 16px;
            font-weight: 500;
            height: 50px;
            line-height: 50px;
            padding: 0 15px;
            transition: all 0.3s;
            
            &:hover, &:focus {
                background-color: rgba(0, 0, 0, 0.05);
            }
            
            &.is-active {
                color: #409EFF;
                font-weight: 600;
                border-bottom: 2px solid #409EFF;
            }
        }
        
        .el-submenu {
            height: 50px;
            line-height: 50px;
            
            .el-submenu__title {
                font-size: 16px;
                font-weight: 500;
                height: 50px;
                line-height: 50px;
                padding: 0 15px;
                
                &:hover {
                    background-color: rgba(0, 0, 0, 0.05);
                }
            }
        }
    }
}

@media (max-width: 768px) {
    #nav-menu-container {
        display: none;
    }
}

/* Mobile Nav Toggle */
#mobile-nav-toggle {
    position: fixed;
    right: 0;
    top: 0;
    z-index: 999;
    margin: 15px 15px 0 0;
    border: 0;
    background: none;
    font-size: 22px;
    display: none;
    transition: all 0.3s;
    outline: none;
    cursor: pointer;
    i {
        color: #555;
    }
}

/* Mobile Nav Styling */
#mobile-nav {
    .el-drawer {
        background: #ffffff !important;
        border-right: 1px solid rgba(0, 0, 0, 0.1);
    }
    
    .drawer-close-btn {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 50%;
        cursor: pointer;
        z-index: 9999;
        
        i {
            font-size: 20px;
            color: #333;
        }
        
        &:hover {
            background-color: rgba(0, 0, 0, 0.1);
        }
    }
    
    .mobile-menu {
        padding-top: 60px;
        background-color: #ffffff !important;
        text-color: #000000 !important;
        active-text-color: #409EFF !important;
        width: 100%;
        
        .custom-menu-item, .custom-submenu {
            position: relative;
            
            .menu-item-content {
                position: absolute;
                left: 0;
                top: 0;
                width: 70%;
                height: 100%;
                z-index: 1;
                display: flex;
                align-items: center;
                padding-left: 20px;
            }
            
            .el-submenu__icon-arrow {
                position: absolute;
                right: 10px;
                top: 50%;
                margin-top: -7px;
                transition: transform .3s;
                font-size: 12px;
                z-index: 0;
            }
        }
        
        .el-submenu__title,
        .el-menu-item {
            background: #ffffff !important;
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            color: #000000 !important;
            font-weight: 500;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            position: relative;
            
            &:hover, &:focus {
                background: #f5f5f5 !important;
                color: #000000 !important;
            }
            
            i {
                color: #000000 !important;
            }
        }
        
        .el-menu-item.is-active {
            background: #f5f5f5 !important;
            color: #409EFF !important;
            font-weight: 600;
            border-left: 3px solid #409EFF;
        }
        
        // Nested menu indentation
        .el-menu {
            .el-menu-item, .el-submenu__title {
                padding-left: 40px !important;
                
                .menu-item-content {
                    padding-left: 40px;
                }
            }
            
            // Second level menu
            .el-menu {
                .el-menu-item, .el-submenu__title {
                    padding-left: 60px !important;
                    
                    .menu-item-content {
                        padding-left: 60px;
                    }
                }
                
                // Third level menu
                .el-menu {
                    .el-menu-item, .el-submenu__title {
                        padding-left: 80px !important;
                        
                        .menu-item-content {
                            padding-left: 80px;
                        }
                    }
                }
            }
        }
        
        .el-submenu.is-opened {
            > .el-submenu__title {
                background: #f9f9f9 !important;
                color: #000000 !important;
                font-weight: 600;
            }
            
            .el-menu {
                background-color: #ffffff !important;
            }
            
            .el-menu-item {
                background-color: #ffffff !important;
                color: #000000 !important;
                
                &.is-active {
                    color: #409EFF !important;
                }
            }
        }
        
        .el-submenu__title {
            color: #000000 !important;
            font-weight: 500;
            
            i {
                color: #000000 !important;
            }
        }
        
        span {
            color: inherit !important;
        }
    }
    
    ul {
        padding: 0;
        margin: 0;
        list-style: none;
        background: inherit;
        border-right: none;
    }
}

/* Override Element UI default text color for mobile menu */
.el-menu--popup {
    background-color: #ffffff !important;
    
    .el-menu-item {
        color: #000000 !important;
        background-color: #ffffff !important;
        
        &:hover, &:focus {
            color: #000000 !important;
            background-color: #f5f5f5 !important;
        }
        
        &.is-active {
            color: #409EFF !important;
            background-color: #f5f5f5 !important;
        }
    }
}

/* Fix for LIBRA submenu items */
.el-menu--vertical {
    .el-menu--popup {
        min-width: 200px;
        
        .el-menu-item {
            color: #000000 !important;
            background-color: #ffffff !important;
            height: 45px;
            line-height: 45px;
            
            &:hover, &:focus {
                color: #000000 !important;
            }
            
            &.is-active {
                color: #409EFF !important;
            }
        }
    }
}

/* Visual hierarchy indicators */
.el-menu--vertical .el-menu-item {
    position: relative;
    
    &::before {
        content: '';
        position: absolute;
        left: 20px;
        top: 50%;
        width: 6px;
        height: 1px;
        background-color: #999;
    }
}

#mobile-body-overly {
    width: 100%;
    height: 100%;
    z-index: 997;
    top: 0;
    left: 0;
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(2px);
}

/* Mobile Nav body classes */
body {
    &.mobile-nav-active {
        overflow: hidden;
        #mobile-nav {
            left: 0;
        }
        #mobile-nav-toggle {
            color: #fff;
        }
    }
}

@media (max-width: 768px) {
    #mobile-nav-toggle {
        display: inline;
    }
}
</style>
